<dx-popup
  [width]="650"
  [height]="750"
  [showTitle]="true"
  title="Izmijeni ponudu"
  [(visible)]="isVisible"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  (onHiding)="onPopupHiding()"
  (onShown)="onPopupShown()">

  <div *dxTemplate="let options of 'content'" class="popup-content-wrapper">
     <div *ngIf="dataLoading" class="data-loading">
      <dx-load-indicator size="small"></dx-load-indicator>
      <span>Učitavanje podataka...</span>
    </div>

    <div class="form-container" [class.loading]="dataLoading">
      <dx-form
        [formData]="ponudaForm.value"
        (onFieldDataChanged)="onFieldDataChanged($event)"
        [readOnly]="false"
        [showColonAfterLabel]="true"
        labelLocation="top"
        class="custom-form">
        
        <dxi-item 
          dataField="artikl" 
          editorType="dxSelectBox" 
          [editorOptions]="artiklEditorOptions"
          label="Artikl">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
         <dxi-item 
          dataField="opis" 
          editorType="dxTagBox" 
          [editorOptions]="opisEditorOptions"
          label="Opis">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="kolicina" 
          editorType="dxNumberBox" 
          [editorOptions]="kolicinaEditorOptions"
          label="Quantity">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="numeric"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="jedinica_mjere" 
          editorType="dxSelectBox" 
          [editorOptions]="jedinicaMjereEditorOptions"
          label="Jedinica mjere">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="fco" 
          editorType="dxSelectBox" 
          [editorOptions]="fcoEditorOptions"
          label="Paritet">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="mjesto_utovara" 
          editorType="dxTextBox" 
          [editorOptions]="mjestoUtovaraEditorOptions"
          label="Mjesto utovara">
        </dxi-item>
        
        <dxi-item 
          dataField="cijena" 
          editorType="dxNumberBox" 
          [editorOptions]="cijenaEditorOptions"
          label="Cijena">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="numeric"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="valuta" 
          editorType="dxSelectBox" 
          [editorOptions]="valutaEditorOptions"
          label="Valuta">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="po_jedinica_mjere" 
          editorType="dxSelectBox" 
          [editorOptions]="jedinicaMjereEditorOptions"
          label="Po jedinica mjere">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item 
          dataField="pdv" 
          editorType="dxTextBox" 
          [editorOptions]="pdvEditorOptions"
          label="PDV">
        </dxi-item>
        
        <dxi-item 
          dataField="nacin_placanja" 
          editorType="dxTextBox" 
          [editorOptions]="nacinPlacanjaEditorOptions"
          label="Nacin placanja">
        </dxi-item>


          <dxi-item 
            dataField="za_drzavu" 
            editorType="dxSelectBox" 
            [editorOptions]="zaDrzavuEditorOptions"
            label="Za državu">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-item>
          
          <dxi-item 
            dataField="za_domace" 
            editorType="dxCheckBox" 
            [editorOptions]="zaDomaceEditorOptions"
            label="Za domaće">
          </dxi-item>
          
          <dxi-item 
            dataField="za_izvoz" 
            editorType="dxSelectBox" 
            [editorOptions]="zaIzvozEditorOptions"
            label="Za izvoz">
          </dxi-item>
        
        <dxi-item 
          dataField="dodatni_opis" 
          editorType="dxTextArea" 
          [editorOptions]="dodatniOpisEditorOptions"
          label="Additional Description">
        </dxi-item>
        
        <dxi-item 
          dataField="firma" 
          editorType="dxSelectBox" 
          [editorOptions]="firmaEditorOptions"
          label="Firma">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item
        label="Telefon"
        dataField="selectedFirma.telefon1"
        editorType="dxTextBox"
        [editorOptions]="readonlyEditorOptions"
        ></dxi-item>
        
        <dxi-item 
          dataField="datum" 
          editorType="dxDateBox" 
          [editorOptions]="datumEditorOptions"
          label="Date">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

      </dx-form>

      <!-- Form Actions -->
      <div class="form-actions">
        <dx-button
          text="Otkaži"
          stylingMode="contained"
          type="default"
          (onClick)="onCancel()"
          class="action-button">
        </dx-button>
        
        <dx-button
          text="Sačuvaj izmjene"
          stylingMode="contained"
          type="default"
          [disabled]="!ponudaForm.valid"
          (onClick)="onSubmit()"
          class="action-button">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<dx-load-panel
  [visible]="loading"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>